import React, { useEffect } from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { SubsidiarySection } from './components/SubsidiarySection';
import { AboutSection } from './components/AboutSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
export function App() {
  // Initialize theme based on user preference or saved setting
  useEffect(() => {
    // Check for saved theme preference and default to light mode
    const savedTheme = localStorage.theme;
    if (savedTheme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, []);
  return <div className="flex flex-col min-h-screen w-full bg-white dark:bg-gray-900 text-foreground" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <HeroSection data-id="element-3" />
        <SubsidiarySection data-id="element-4" />
        <AboutSection data-id="element-5" />
        <ContactSection data-id="element-6" />
      </main>
      <Footer data-id="element-7" />
    </div>;
}